import React from 'react'
import { X } from 'react-feather'

const Label = ({children}) => {
  return (
    <div className="rounded bg-primary text-white px-2 text-xs mr-2 flex items-center cursor-pointer">
      {children} <X className="ml-3" style={{width: '14px'}}/>
    </div>
  )
}

const ListFilter = ({setFiltered}) => {
  return (
    <div>
      <div className="flex items-center mb-10" onClick={() => setFiltered(false)}>
        <Label>Jawa Barat</Label>
        <Label>NGO</Label>
        <Label>Donor</Label>
        <div className="underline text-xs ml-4 cursor-pointer">Clear all filters</div>
      </div>
    </div>
  )
}

export { ListFilter }